import { Subject } from 'rxjs';

const subject = new Subject<boolean>();

export const LoadingService = {
    sendLoadingAtivo: (msg: boolean) => subject.next(msg),
    getLoadingAtivo: () => subject.asObservable()
};